/* src/app/private/components/analytics/pie-chart/pie-chart.component.scss */
.p-card {
  height: 100%;
}
.chart,
h4 {
  color: rgb(43, 208, 41);
  font-size: 15px;
  margin-top: 10px;
}
.chart h2 {
  font-size: 20px;
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 0;
  color: var(--bg);
}
.chart h4 {
  margin-left: 20px;
  margin-bottom: 2px;
  color: var(--dark-grey);
}
.graph_ {
  margin: 10px;
  width: 50%;
}
.section {
  background: #fff;
}
.chart {
  padding: 5px;
  display: flex;
  flex-direction: row;
}
.circle_graph_right {
  display: flex;
  flex-direction: row;
  justify-content: CENTER;
  align-items: CENTER;
}
.h-social-img {
  display: flex;
  flex-direction: column;
  align-items: CENTER;
}
.h-social-img img {
  width: 24px;
}
.canvas {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
}
.section {
  padding: 25px;
  border-radius: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title {
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #0D4259;
  margin-top: -18px;
}
.sub-title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #767373;
  margin-top: 4px;
  margin-bottom: 14px;
}
.canvasStyle {
  display: block;
  box-sizing: border-box;
  height: 218px;
  width: 228px;
}
.charBox {
  width: 100%;
  margin: auto;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
@media (max-width: 1220px) {
  .canvasStyle {
    height: 180px !important;
    width: 180px !important;
  }
}
@media (min-width: 1220px) {
  .canvasStyle {
    display: block;
    box-sizing: border-box;
    height: 218px !important;
    width: 228px !important;
  }
}
@media (min-width: 1500px) {
  .canvasStyle {
    display: block;
    box-sizing: border-box;
    height: 318px !important;
    width: 328px !important;
  }
}
@media (min-width: 1800px) {
  .canvasStyle {
    display: block;
    box-sizing: border-box;
    height: 418px !important;
    width: 428px !important;
  }
}
@media (max-width: 1024px) {
  .canvas {
    width: 100%;
    overflow-x: auto;
    margin: 0 -2px;
    -webkit-overflow-scrolling: touch;
    text-align: center;
  }
  .canvasStyle {
    height: 150px !important;
    width: 150px !important;
  }
  .charBox {
    min-width: 360px;
  }
  .section {
    overflow: auto;
  }
}
/*# sourceMappingURL=pie-chart.component.css.map */
